import { arrayOf, bool, shape, string } from 'prop-types'
import { useState } from 'react'
import { Transition } from 'react-transition-group'
import AccordionText from './accordion-text'

const AccordionTextGroup = ({ defaultExpanded, accordions, exclusive, TransitionProps }) => {
	const [expanded, setExpanded] = useState(defaultExpanded ? { [defaultExpanded]: true } : {})

	const handleChange = (panelId) => (event, isExpanded) => {
		setExpanded(exclusive ? { [panelId]: isExpanded } : { ...expanded, ...{ [panelId]: isExpanded } })
	}
	return accordions
		?.filter((accordion) => Object.keys(accordion).length > 0)
		.map(({ onChange, id, ...props }) => (
			<AccordionText
				key={id}
				onChange={(...args) => {
					handleChange(id)(...args)
					if (onChange) {
						onChange(...args)
					}
				}}
				expanded={expanded[id] || false}
				TransitionProps={TransitionProps}
				{...props}
			/>
		))
}

AccordionTextGroup.defaultProps = {
	defaultExpanded: '',
	exclusive: true,
}

AccordionTextGroup.propTypes = {
	/**
	 * Accordions children to the AccordionGroup.
	 */
	accordions: arrayOf(shape({ ...AccordionText.propTypes })).isRequired,
	/**
	 * Enables exclusive expansion mode for the accordion group.
	 * Default is `true`, which means that only one accordion can be expanded at a time.
	 */
	exclusive: bool,
	defaultExpanded: string,
	TransitionProps: shape({ ...Transition.propTypes }),
}

export default AccordionTextGroup
